module.exports = require('./helpers/bundle-url').getBundleURL('ax7c2') + "logo-dark.eefe0b7f.svg";